// Contract addresses for Zubari ecosystem
export interface ContractAddresses {
  registry: string;
  nft: string;
  marketplace: string;
  tips: string;
  subscriptions: string;
  payouts: string;
  entryPoint: string;
  paymaster: string;
  accountFactory: string;
  usdt: string;
  weth: string;
}

// Placeholder addresses - will be updated after deployment
const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const ZUBARI_CONTRACTS: Record<'testnet' | 'mainnet', ContractAddresses> = {
  testnet: {
    // Ethereum Sepolia (11155111) - Deployed 2024-12-09
    registry: '0xEdDf443D48832f23D4A0bED4C4c5eF200B38A7d3',
    nft: '0xdc37e25650D685e4c38124aC314477Ea5f508a9e',
    marketplace: ZERO_ADDRESS, // Not yet deployed
    tips: '0xFDc353edC63Cd3D4bba35bB43861369516a9Dc85',
    subscriptions: '0x8C05F8aD2F295fB7f3596043a7c37C98A5F7fAB8',
    payouts: '0x804Fe503936E8b8d3D5Dbb62AF4fB6Fe7265Fb2c',
    entryPoint: '0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789',
    paymaster: ZERO_ADDRESS, // Not yet deployed
    accountFactory: ZERO_ADDRESS, // Not yet deployed
    usdt: '0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0', // USDT on Sepolia
    weth: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
  },
  mainnet: {
    // Ethereum Mainnet (1)
    registry: ZERO_ADDRESS,
    nft: ZERO_ADDRESS,
    marketplace: ZERO_ADDRESS,
    tips: ZERO_ADDRESS,
    subscriptions: ZERO_ADDRESS,
    payouts: ZERO_ADDRESS,
    entryPoint: '0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789',
    paymaster: ZERO_ADDRESS,
    accountFactory: ZERO_ADDRESS,
    usdt: '0xdAC17F958D2ee523a2206206994597C13D831ec7', // USDT on Ethereum
    weth: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  },
};

// Platform configuration
export const PLATFORM_CONFIG = {
  // Platform fee in basis points (300 = 3%)
  tipFeeBps: 300,
  // Maximum royalty in basis points (1000 = 10%)
  maxRoyaltyBps: 1000,
  // Default slippage tolerance for swaps (50 = 0.5%)
  defaultSlippageBps: 50,
  // Voucher validity in seconds (30 days)
  voucherValiditySecs: 30 * 24 * 60 * 60,
  // Swap deadline in seconds (30 minutes)
  swapDeadlineSecs: 30 * 60,
} as const;

// EIP-712 Domain for lazy minting
export const NFT_VOUCHER_DOMAIN = {
  name: 'ZubariNFT',
  version: '1',
} as const;

export const NFT_VOUCHER_TYPES = {
  NFTVoucher: [
    { name: 'tokenId', type: 'bytes32' },
    { name: 'uri', type: 'string' },
    { name: 'creator', type: 'address' },
    { name: 'royaltyBps', type: 'uint256' },
    { name: 'deadline', type: 'uint256' },
  ],
} as const;

export function getContractAddresses(network: 'testnet' | 'mainnet'): ContractAddresses {
  return ZUBARI_CONTRACTS[network];
}
